import { render, staticRenderFns } from "./wtMainStoryView.vue?vue&type=template&id=24dc3d32&"
import script from "./wtMainStoryView.vue?vue&type=script&lang=js&"
export * from "./wtMainStoryView.vue?vue&type=script&lang=js&"
import style0 from "./wtMainStoryView.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports